import React from 'react'

const cta = () => {
  return (
    <div className='cta'>
        <a href="https://drive.google.com/file/d/15pxofKs6uElms1Ou-RA4vKtrLKQkOAHR/view?usp=sharing" target="_blank" className='btn'>Download Resume</a>
        <a href="#contact" className='btn btn-primary'>Let's Talk</a>
      </div>
    )
}

export default cta